import styled from 'styled-components';

export const PersonalizationStyled = styled.div`
  .Personalization_card {
    display: flex;
    gap: 1px;
    justify-content: space-between;
    .personalization_text {
      margin: 10px 100px 0 0;
    }
    .custom_block_title {
      font-size: 16px;
      font-weight: 700;
      align-items: center;
    }
    .personalization_button {
      margin: 10px 10px 0 0;
    }
  }
`;
